import { boolean, number, object, string } from "yup";

export const updateVideoValidationSchema = object().shape({
    title: string().required("Title is required"),
    description: string().required("Description is required"),
    thumbnailId: number().required("Thumbnail is required"),
    isTrailer: boolean().required("Is Trailer is required"),
    publisherId: number().positive().required("Publisher is required"),
});
